import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { UserRestService } from "src/providers/user-restservice";
import { DeviceDetectorService } from "src/services/device-detector.service";
import { TokenStorageService } from "src/services/token-storage.service";
import { TransferStateService } from "src/services/transfer-state.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {

  headerText: string = "";
  white: boolean = false;
  blue: boolean = false;

  mobile:boolean = false;

  btnLogOut: boolean = false;
  username!: string;
  email!: string;

  constructor(
    private router : Router,
    private _deviceDetectorService : DeviceDetectorService,
    private _tokenStorageService : TokenStorageService,
    private _transferStateService : TransferStateService,
    private _userRestService : UserRestService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let currentUrl = event.url;

        this.headerText = "";
        this.white = false;
        this.blue = false;
        this.btnLogOut = false;

        if (!this._deviceDetectorService.isMobileDevice() || window.innerWidth > 600) {
          this.mobile = false;
          if (currentUrl === '/survey') {
            this.white = true;
            this.headerText = "Cuestionario";
          } else if (currentUrl === '/survey/recording') {
            this.white = true;
            this.headerText = "Test de Lenguaje";
          } else if (currentUrl === '/survey/results') {
            this.blue = true;
            this.headerText = "Resultado";
          } else if (currentUrl === '/auth/register') {
            this.blue = true;
          } else if (currentUrl === '/intro'){
            this.blue = true;
          } else if (currentUrl === '/users') {
            this.blue = true;
            this.headerText = "Gestión de datos";
            if (this._transferStateService.getToken() != null){
              this.btnLogOut = true;
              this._userRestService.getUserById(this._transferStateService.getItem("userId")).subscribe((result : any ) => {
                //console.log(result);
                this.username = result.data.name;
                this.email = result.data.email;
              })
            }
            else{
              this.router.navigate(['/auth']);
            }
          }
        }
        else {
          if (window.innerWidth < 600) {
            this.mobile = true;
          }
          if (currentUrl === '/survey') {
            this.white = true;
            this.headerText = "Cuestionario";
          } else if (currentUrl === '/survey/recording') {
            this.white = true;
            this.headerText = "Test de Lenguaje";
          } else if (currentUrl === '/users') {
            this.white = true;
            if (this._transferStateService.getToken() != null){
              this.btnLogOut = true;
              this._userRestService.getUserById(this._transferStateService.getItem("userId")).subscribe((result : any ) => {
                //console.log(result);
                this.username = result.data.name;
                this.email = result.data.email;
              })
            }
            else{
              this.router.navigate(['/auth']);
            }
          }
        }
      }
    });
  }

  ngOnInit() {

  }

  logout(){
    this._tokenStorageService.signOut();
    this.router.navigate(['/auth']);
  }
}
